export const SidebarActionTypes = {
    SWITCH_TO_OVERVIEW: "SWITCH_TO_OVERVIEW",
    SWITCH_TO_PRODUCTS_LISTS: "SWITCH_TO_PRODUCTS_LISTS",
    SWITCH_TO_CUSTOMERS_LISTS: "SWITCH_TO_CUSTOMERS_LISTS",
    SWITCH_TO_ADD_PRODUCTS: "SWITCH_TO_ADD_PRODUCTS",
    SWITCH_TO_UPDATE_PRODUCTS: " SWITCH_TO_UPDATE_PRODUCTS",
};
